var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":"/roast/roast"}},[_c('img',{staticClass:"bg",attrs:{"alt":"","src":require("../../assets/photo/web_1.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }